(function () {
  function buildVariantUrl(link) {
    var current = new URL(window.location.href);
    var next = new URL(link.href, current);
    var preservedKeys = [];

    current.searchParams.forEach(function (_value, key) {
      if (key !== 'variant' && key.indexOf('ry_') !== 0 && preservedKeys.indexOf(key) === -1) {
        preservedKeys.push(key);
      }
    });

    preservedKeys.forEach(function (key) {
      next.searchParams.delete(key);
      current.searchParams.getAll(key).forEach(function (value) {
        next.searchParams.append(key, value);
      });
    });

    next.searchParams.set('variant', link.dataset.ryPackageOption);
    return next.toString();
  }

  function initialize() {
    document.querySelectorAll('[data-ry-package-selector]').forEach(function (selector) {
      if (selector.dataset.ryPackageReady === 'true') return;
      selector.dataset.ryPackageReady = 'true';

      selector.querySelectorAll('[data-ry-package-option]').forEach(function (option) {
        option.addEventListener('click', function (event) {
          if (option.dataset.packageAvailable !== 'true') {
            event.preventDefault();
            return;
          }

          event.preventDefault();
          window.location.assign(buildVariantUrl(option));
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
